import { useQuery } from '@tanstack/react-query';
import { fetchRoster } from '../api/client';

export function useRoster(competitionId, enabled = true) {
  return useQuery({
    queryKey: ['roster', competitionId],
    queryFn: () => fetchRoster(competitionId),
    enabled: Boolean(enabled && competitionId),
    staleTime: 120_000,
  });
}
